module.exports = __webpack_public_path__ + "img/profit.fad32528.svg";